import { render } from "./menuStart.vue?vue&type=template&id=a9bbde80&scoped=true"
import script from "./menuStart.vue?vue&type=script&lang=js"
export * from "./menuStart.vue?vue&type=script&lang=js"

import "./menuStart.vue?vue&type=style&index=0&id=a9bbde80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9bbde80"

export default script